
import ScrollReveal from '../components/ScrollReveal';
import { useLanguage } from '../contexts/LanguageContext';

const HeroSection = () => {
  const { tString } = useLanguage();

  return (
    <div
      id="start"
      className="scroll-mt-40 w-screen h-screen relative bg-cover bg-center md:bg-fixed flex items-center justify-center text-white"
      style={{ backgroundImage: "url('/images/header.png')" }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-[#2a3342]/90 z-0" />

      {/* Content */}
      <div className="font-poppins text-center px-6 md:px-16 z-10">
        <ScrollReveal direction="up" delay={0.3} duration={1.0}>
          <img
            src="/images/logo_inicio.png"
            alt="Montelo Logo"
            className="mx-auto max-w-xs md:max-w-3xl mb-10"
          />
        </ScrollReveal>
        <ScrollReveal direction="up" delay={0.6} duration={0.8}>
          <a href="#contact">
            <button className="bg-[#29519F] hover:bg-blue-700 text-white font-bold py-3 px-24 rounded">
              {tString('hero.contactButton')}
            </button>
          </a>
        </ScrollReveal>
      </div>

      {/* Bottom Info Wrapper */}
      <div className="absolute bottom-4 w-full flex flex-col items-center gap-y-4 md:flex-row md:justify-between px-6 z-10">
        {/* Bottom Left */}
        <ScrollReveal direction="left" delay={0.9} duration={0.8}>
          <div className="flex items-center gap-3">
            <img src="/images/mexico.png" alt="Truck Left" className="w-10 h-10" />
            <p className="text-sm font-bold text-[#CBD5E1]">{tString('hero.companyMexico')}</p>
          </div>
        </ScrollReveal>
        <ScrollReveal direction="left" delay={0.9} duration={0.8}>
          <div className="flex items-center">
            <img src="/images/certificate.png" alt="Truck Left" className="w-40" />
          </div>
        </ScrollReveal>
        {/* Bottom Right */}
        <ScrollReveal direction="right" delay={1.0} duration={0.8}>
          <div className="flex items-center gap-3">
            <p className="text-sm font-bold text-[#CBD5E1]">{tString('hero.companyUSA')}</p>
            <img src="/images/usa.png" alt="Globe Right" className="w-10 h-10" />
          </div>
        </ScrollReveal>
      </div>
    </div>
  );
};

export default HeroSection;
